/**
 * Guidelines API — guideline read surface + PDF import / create.
 *
 * Ported from digital_sizer (pages/Guidelines.tsx). Now wired onto the LOS client
 * (`dsHttp` → eastview-los), per the digital-sizer base-URL removal.
 *
 * ⚠️ TBD: eastview-os has NO `/guidelines/*` router yet. Every call below 404s
 * until the backend adds an eastview-os equivalent — point these at the real
 * paths when they land.
 */
import { dsHttp } from "../lib/digitalSizerHttp";

export const guidelinesApi = {
  // TBD (no eastview-os route): GET /guidelines
  list: () => dsHttp.get("/guidelines").then((r) => r.data),

  // TBD (no eastview-os route): GET /guidelines/:slug
  get: (slug) => dsHttp.get(`/guidelines/${slug}`).then((r) => r.data),

  // TBD (no eastview-os route): GET /guidelines/:slug/revisions
  revisions: (slug) =>
    dsHttp.get(`/guidelines/${slug}/revisions`).then((r) => r.data),

  // TBD (no eastview-os route): POST /guidelines/import-pdf (multipart)
  importPdf: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return dsHttp.post("/guidelines/import-pdf", fd).then((r) => r.data);
  },

  // TBD (no eastview-os route): POST /guidelines/
  create: (body) => dsHttp.post("/guidelines/", body).then((r) => r.data),

  // TBD (no eastview-os route): PUT /guidelines/:slug
  update: (slug, body) =>
    dsHttp.put(`/guidelines/${slug}`, body).then((r) => r.data),
};

export default guidelinesApi;
